import "./App.css"
import LandingPage from "./features/multiWorld/LandingPage"

const App = () => {
  return (
      <div className="flex flex-1 justify-center items-center">
        <LandingPage />
      </div>
  )
}

export default App
